export const COMPANY = {
  name: "Thunderbird Geospatial Inc.",
  short: "Thunderbird Geospatial",
  tagline: "Precision mapping from above.",
  address: "875 Gateway Rd #13, Winnipeg, MB R2K 3L1",
  city: "Winnipeg, Manitoba",
  phone: "(431) 294-3811",
  phoneHref: "tel:+14312943811",
  email: "admin@tbirdgeo.com",
  website: "https://tbirdgeo.com",
};

export const NAV_LINKS = [
  { label: "Services", href: "/#services" },
  { label: "Process", href: "/#process" },
  { label: "Work", href: "/#showcase" },
  { label: "Why Us", href: "/#why" },
  { label: "STUDIOS", href: "/studios", route: true, accent: true },
  { label: "AgTech", href: "/tbirdag", route: true },
  { label: "Ground School", href: "/groundschool", route: true },
  { label: "Viewer", href: "/viewer", route: true },
  { label: "Contact", href: "/#quote" },
];

export const SERVICES = [
  {
    title: "Aerial Surveys",
    desc: "Survey-grade aerial data capture with centimeter-level precision across any terrain.",
    icon: "plane",
    size: "col-span-1 md:col-span-2 row-span-1",
    tag: "Core",
  },
  {
    title: "Drone Mapping",
    desc: "Advanced UAV platforms for fast, safe, and accurate geospatial collection.",
    icon: "map",
    size: "col-span-1 row-span-1",
    tag: "UAV",
  },
  {
    title: "Orthomosaic Mapping",
    desc: "True-ortho stitched imagery for planning, measurement, and documentation.",
    icon: "layers",
    size: "col-span-1 row-span-1",
    tag: "Imagery",
  },
  {
    title: "3D Terrain Modeling",
    desc: "High-fidelity digital surface and elevation models from dense point clouds.",
    icon: "mountain",
    size: "col-span-1 md:col-span-2 row-span-1",
    tag: "3D",
  },
  {
    title: "LiDAR & 3D Scanning",
    desc: "Airborne and terrestrial LiDAR capture for infrastructure and asset documentation.",
    icon: "radar",
    size: "col-span-1 row-span-1",
    tag: "LiDAR",
  },
  {
    title: "GIS Solutions",
    desc: "Spatial analysis and GIS workflows that turn raw data into decisions.",
    icon: "globe",
    size: "col-span-1 row-span-1",
    tag: "GIS",
  },
  {
    title: "Construction Progress",
    desc: "Repeatable aerial captures to track progress, quality, and schedule.",
    icon: "crane",
    size: "col-span-1 row-span-1",
    tag: "Construction",
  },
  {
    title: "Agriculture Mapping & Analysis",
    desc: "Aerial LiDAR and photogrammetry — terrain data for drainage, crop density mapping, and field-grade elevation models for precision agriculture across Canada.",
    icon: "sprout",
    size: "col-span-1 md:col-span-2 row-span-1",
    tag: "AgTech",
    featured: true,
  },
  {
    title: "Volumetric Analysis",
    desc: "Stockpile and earthwork volumes calculated from high-density point clouds.",
    icon: "cube",
    size: "col-span-1 row-span-1",
    tag: "Analytics",
  },
  {
    title: "Asset Management",
    desc: "Digital twins and spatial asset registries for long-term infrastructure tracking.",
    icon: "layers",
    size: "col-span-1 row-span-1",
    tag: "Assets",
  },
  {
    title: "Inspections & Thermal Imaging",
    desc: "Safe aerial inspection and thermal imaging for infrastructure, rooftops, towers, and assets.",
    icon: "camera",
    size: "col-span-1 md:col-span-2 row-span-1",
    tag: "Inspection",
  },
];

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "Consultation",
    desc: "We scope project goals, deliverables, accuracy, and timelines with your team.",
  },
  {
    n: "02",
    title: "Site Planning",
    desc: "Flight plans, GCPs, airspace authorizations, and safety protocols are prepared.",
  },
  {
    n: "03",
    title: "Data Capture",
    desc: "Certified pilots operate professional UAV platforms to collect survey-grade data.",
  },
  {
    n: "04",
    title: "Processing & Analysis",
    desc: "Imagery is processed into orthomosaics, DSMs, 3D models, and analytics layers.",
  },
  {
    n: "05",
    title: "Final Deliverables",
    desc: "Clean, documented outputs delivered in the formats your workflow requires.",
  },
];

export const TESTIMONIALS = [
  {
    quote: "Great service, quick turnaround time.",
    author: "Construction client",
    role: "Winnipeg, MB",
  },
  {
    quote: "Very professional and timely.",
    author: "Property owner",
    role: "Manitoba",
  },
  {
    quote: "The end result was really cool to see.",
    author: "Project lead",
    role: "Development firm",
  },
];

export const STATS = [
  { value: "Indigenous-owned", label: "Treaty One Territory, MB" },
  { value: "Multi-sensor", label: "LiDAR, RGB, thermal" },
  { value: "Documented QA", label: "Every engagement" },
  { value: "Full-stack", label: "Geomatics + Film / VFX" },
];

export const WHY_POINTS = [
  {
    title: "Fast turnaround",
    desc: "Rapid deliverables from flight day to final package — kept on schedule without sacrificing accuracy.",
  },
  {
    title: "Advanced drone tech",
    desc: "Modern UAV platforms with RTK/PPK and multi-sensor payloads.",
  },
  {
    title: "Regulatory handled",
    desc: "We manage Transport Canada approvals, NAV drone, and site safety.",
  },
  {
    title: "Local Manitoba HQ, national reach",
    desc: "Winnipeg-based crew, mobilizing across Canada for multi-site programs.",
  },
  {
    title: "Accurate deliverables",
    desc: "Ground-controlled captures with documented QA on every project.",
  },
  {
    title: "Enterprise-ready",
    desc: "Workflows built for construction, engineering, and municipal clients.",
  },
];

export const SHOWCASE_IMAGES = [
  {
    src: "https://customer-assets.emergentagent.com/job_tbirdgeo-preview/artifacts/2iqzxjc0_IMAGE8.JPG",
    title: "Preserving our Communities",
    subtitle: "Nisichawayasihk Cree Nation",
    tag: "Land management",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_tbirdgeo-preview/artifacts/z9z5b282_image3.jpg",
    title: "Bare-earth terrain",
    tag: "Drainage",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_tbirdgeo-preview/artifacts/fd5wx2ue_Screenshot%202026-05-12%20190235.png",
    title: "LiDAR - CAD",
    tag: "Engineering",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_tbirdgeo-preview/artifacts/g9me5rq3_Screenshot%202024-10-26%20083702.png",
    title: "Orthomosaic",
    tag: "Mapping",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_tbirdgeo-preview/artifacts/kszu5k19_Screenshot%202024-06-13%20095808.png",
    title: "QA/QC",
    tag: "GIS",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_tbirdgeo-preview/artifacts/7db6749u_Screenshot%202025-09-07%20185510.png",
    title: "3D Meshing",
    tag: "Infrastructure",
  },
];

export const SERVICE_OPTIONS = [
  "Aerial Surveys",
  "Drone Mapping",
  "Orthomosaic Mapping",
  "3D Terrain Modeling",
  "LiDAR & 3D Scanning",
  "GIS Solutions",
  "Agriculture Mapping & Analysis",
  "Construction Progress Monitoring",
  "Volumetric Analysis",
  "Asset Management",
  "Inspections & Thermal Imaging",
  "TGI Studios — VFX / Aerial Cinematics",
  "Other / Not sure yet",
];
